import { Button, List, Modal, ThemeIcon } from "@mantine/core"
import { IconTrashFilled } from "@tabler/icons-react"
import { FileImage } from "lucide-react"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

type Props = {
  opened: boolean
  open: any
  close: any
  files: string[]
  fileType: string
  fileNames: string[]
  remove: (item: string) => void
  removeLoading?: boolean
}
function FileViewerModal({
  close,
  files,
  fileNames,
  fileType,
  open,
  opened,
  removeLoading = false,
  remove,
}: Props) {
  const { t } = useTranslation()
  const [selected, setSelected] = useState<string>("")
  if (process.env.NODE_ENV === "development" && typeof remove !== "function") {
    console.error("🚀 ~ remove:", remove)
    // throw new Error("FileViewerModal requires a valid 'remove' function prop.")
  }

  return (
    <Modal opened={opened} onClose={close} withCloseButton={false}>
      <List
        spacing={"lg"}
        size={"lg"}
        center
        icon={
          <ThemeIcon color="gray">
            <FileImage size={16} />
          </ThemeIcon>
        }
      >
        {files &&
          files?.length > 0 &&
          files?.map((file: string, i: number) => (
            <List.Item>
              <span className="flex  justify-between items-center w-full gap-16">
                <a
                  key={i}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={file}
                >
                  {t("viewFile", { fileType: fileType })}
                </a>

                {fileNames?.length > 0 && (
                  <Button
                    unstyled
                    onClick={() => {
                      setSelected(file)
                      remove(fileNames[i])
                    }}
                    loading={removeLoading && selected === file}
                  >
                    <IconTrashFilled
                      className={`text-[#EC4899] cursor-pointer  ${
                        removeLoading && selected === file ? "hidden" : ""
                      }`}
                      size={24}
                    />
                  </Button>
                )}
              </span>
            </List.Item>
          ))}
      </List>
    </Modal>
  )
}

export default FileViewerModal
